import {PageLayout, Filters} from '~/components'
import {Environment} from '@eitje/api'
import {Map} from './map'
import {useState} from 'react'
import {MapPageHeader} from './map_page_header'

const filters = [
	{name: 'firmStatus'},
	{name: 'organisation', fixedFilter: 'withCoordinates'},
	{name: 'environment', fixedFilter: 'withCoordinates'},
]

export const EnvironmentsMap = () => {
	const [showLabels, setShowLabels] = useState(false)
	const items = Environment.useAll().filter(env => env.lat && env.lng)

	return (
		<PageLayout
			name="map"
			headers={[<MapPageHeader key={0} />, <Filters key={1} />]}
			state={{showLabels, setShowLabels}}
			filterProps={{items, filters}}
			unsetPagePadding
		>
			<Map />
		</PageLayout>
	)
}
